/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./task-center-item.vue?vue&type=template&id=389e0f8f&scoped=true&"
import script from "./task-center-item.vue?vue&type=script&lang=ts&"
export * from "./task-center-item.vue?vue&type=script&lang=ts&"
import style0 from "./task-center-item.vue?vue&type=style&index=0&id=389e0f8f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389e0f8f",
  null
  
)

export default component.exports